import { inject, Injectable } from '@angular/core';
import { CustomerClientDto } from '../dtos/customer.dto';
import { HttpClient } from '@angular/common/http';
import { ResponseDto } from '../dtos/response.dto';
import { finalize, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CustomerService } from './customer.service';
import { LoginRequestDto } from '../dtos/login-request.dto';
import { LoginConfirmClientDto } from '../dtos/login-confirm.dto';
import { ResetPasswordConfirmDto } from '../dtos/reset-password-confirm.dto';
import { OtpRequestClientDto } from '../dtos/otp-request.dto';
import { LoginResponseDto } from '../dtos/login-response.dto';
import { ResetPasswordInitDto } from '../dtos/reset-password-init.dto';
import { ResetPasswordOtpDto } from '../dtos/reset-password-otp.dto';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private customerService = inject(CustomerService);

  isCustomerLoading: boolean = false;

  fetchAndSetCustomer() {
    this.isCustomerLoading = true;
    return this.http.get<ResponseDto<CustomerClientDto>>(`${environment.apiHost}/api/v1/auth`)
      .pipe(
        tap(response => this.customerService.setCustomer(response.data)),
        finalize(() => this.isCustomerLoading = false),
      );
  }

  login(loginDto: LoginRequestDto) {
    return this.http.post<ResponseDto<LoginResponseDto>>(`${environment.apiHost}/api/v1/auth`, loginDto);
  }

  loginConfirm(loginConfirmDto: LoginConfirmClientDto) {
    return this.http.post<ResponseDto<CustomerClientDto>>(`${environment.apiHost}/api/v1/auth/confirm`, loginConfirmDto)
      .pipe(tap(response => this.customerService.setCustomer(response.data)));
  }

  logout(): void {
    this.http.post(`${environment.apiHost}/api/v1/auth/logout`, { })
      .subscribe(_ => this.customerService.setCustomer(null));
  }

  resetPasswordInit(login: string) {
    const dto: ResetPasswordInitDto = {
      login: login,
    };
    return this.http.post<ResponseDto<OtpRequestClientDto>>(`${environment.apiHost}/api/v1/auth/reset-password/init`, dto);
  }

  resetPasswordOtp(dto: ResetPasswordOtpDto) {
    return this.http.post<ResponseDto<true>>(`${environment.apiHost}/api/v1/auth/reset-password/otp`, dto);
  }

  resetPasswordConfirm(dto: ResetPasswordConfirmDto) {
    return this.http.post<ResponseDto<CustomerClientDto>>(`${environment.apiHost}/api/v1/auth/reset-password/confirm`, dto)
      .pipe(tap(response => this.customerService.setCustomer(response.data)));
  }

  getSocialLoginUrl(provider: 'google' | 'facebook'): string {
    return `${environment.apiHost}/api/v1/auth/login/${provider}`;
  }
}
